// Function loadInstagramBlock loads the InstagramBlock class by dynamically importing the js on demand if needed

export function loadQuoteBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-instagram-block-chunk" */ '../widgets/quoteBlock').then(wg => {

		const { QuoteBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="QuoteBlock"]');

		if(!$wg) {
			// console.info('InstagramBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="QuoteBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new QuoteBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new QuoteBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopFeaturedGridItemBlock widget');

}
